import {
    GET_ACTIVE_ASSET_EXCEL_DATA,
    SET_ACTIVE_ASSET_EXCEL_DATA,
    SET_ACTIVE_ASSET_GRID_FILTERS,
    GET_ACTIVE_ASSET_GRID_DATA,
    SET_ACTIVE_ASSET_GRID_DATA,
    SET_IS_GRID_DATA_LOADING
} from "./ActiveAssetDashboardType"

const getActiveAssetExcelData = (payload: any) => ({
    type: GET_ACTIVE_ASSET_EXCEL_DATA,
    payload
});

const setActiveAssetExcelData = (activeAssetExcelData: any) => ({
    type: SET_ACTIVE_ASSET_EXCEL_DATA,
    activeAssetExcelData
})

const setActiveAssetGridFilter = (activeAssetGridFilters: any) => ({
    type: SET_ACTIVE_ASSET_GRID_FILTERS,
    activeAssetGridFilters
})

const getActiveAssetGridData = (payload: any) => ({
    type: GET_ACTIVE_ASSET_GRID_DATA,
    payload
});

const setActiveAssetGridData = (activeAssetGridData: any) => ({
    type: SET_ACTIVE_ASSET_GRID_DATA,
    activeAssetGridData
})

const setIsGridDataLoading = (isGridDataLoading: any) => ({
    type: SET_IS_GRID_DATA_LOADING,
    isGridDataLoading
})

export {
    getActiveAssetExcelData,
    setActiveAssetExcelData,
    setActiveAssetGridFilter,
    getActiveAssetGridData,
    setActiveAssetGridData,
    setIsGridDataLoading
}